import InfoArticleHeader from './header';
import InfoDetailArticleMain from './main';
import { InfoDetailVO } from '@domain/vo/info/infoDetailVO';
import classnames from 'classnames/bind';
import styles from './infoDetailArticle.module.scss';

const cx = classnames.bind(styles);

interface IInfoDetailArticleProps {
  detailData: InfoDetailVO;
}

const InfoDetailArticle = (props: IInfoDetailArticleProps) => {
  const { detailData } = props;

  return (
    <article className={cx('article')}>
      <InfoArticleHeader detailData={detailData} />
      <hr className={cx('divider')} />
      <InfoDetailArticleMain content={detailData?.contents ?? ''} />
    </article>
  );
};

export default InfoDetailArticle;
